var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipClinicalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Design",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#008aed;fill-rule:evenodd;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.83,53.26c-2.22-2.06-3.61-5-3.61-8.26s1.39-6.2,3.61-8.26c.6-.56,1.26-1.05,1.97-1.46,2.22-2.06,3.61-5,3.61-8.26,0-6.22-5.05-11.27-11.28-11.27s-11.28,5.05-11.28,11.27c0,3.26,1.39,6.2,3.61,8.26.71.41,1.37.91,1.97,1.46,2.22,2.06,3.61,5,3.61,8.26s-1.39,6.2-3.61,8.26c-.6.56-1.26,1.05-1.97,1.46-2.22,2.06-3.61,5-3.61,8.26,0,6.22,5.05,11.27,11.28,11.27s11.28-5.04,11.28-11.27c0-3.26-1.39-6.2-3.61-8.26-.71-.41-1.37-.91-1.97-1.46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.03,40.75c3.5,3.57,1.95,10.22-4.59,11.03-6.51-.95-7.95-7.62-4.39-11.12,2.5-2.46,6.52-2.42,8.98.09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.03,40.75c3.5,3.57,1.95,10.22-4.59,11.03-6.51-.95-7.95-7.62-4.39-11.12,2.5-2.46,6.52-2.42,8.98.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipClinicalIcon);
export default __webpack_public_path__ + "static/media/HIP Clinical Icon.a2ee4f68fc8ef6f659ca7526f497591f.svg";
export { ForwardRef as ReactComponent };